export const TAXID_TYPE = {
  BR_CPF: 'BR:CPF',
  BR_CNPJ: 'BR:CNPJ',
  US_SOCIALSECURITY: 'US:SOCIALSECURITY',
} as const;
export type TAXID_TYPE = (typeof TAXID_TYPE)[keyof typeof TAXID_TYPE];
